import { DateRange } from 'react-day-picker';
import { fromZonedTime } from 'date-fns-tz';

export const zonedDateRangeToUtc = (
  dateRange: DateRange | undefined,
  timeZone: string
): DateRange | undefined => {
  if (!dateRange) {
    return undefined;
  }

  const from = dateRange.from
    ? fromZonedTime(dateRange.from, timeZone)
    : undefined;
  const to = dateRange.to ? fromZonedTime(dateRange.to, timeZone) : undefined;

  return { from, to };
};
